import React, { useEffect, useState, useRef } from "react";
import { Tabs } from "antd";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import ListFooter from "swfrontend/MDM/MDMScreens/ListView/ListFooter.js";
import { localStorageVariableName, route_url } from "swfrontend/AppConfigs";
import {
    notificationMessage,
    openNotificationType,
    notificationTitle,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import ListHeader from "./Components/CustomListHeader";
import FeedbackListCellButton from './Components/FeedbackListCellButton'
import { DataProvider } from "../../DataProvider";
import { FEEDBACK_LIST_COLUNMN_DEFS } from "../../Constants";

let gridApi = null;
const dataProvider = new DataProvider();
const loggedinUser = localStorage.getItem(localStorageVariableName.userName);
const onFirstDataRendered = (params) => params.api.sizeColumnsToFit();
const onGridReady = (params) => {
    gridApi = params.api;
};

const AllFeedback = ({ history }) => {
    const gridRef = useRef();
    const [activeTab, setActiveTab] = useState("Open for Feedback")
    const [state, setState] = useState({
        selectedRow: null,
        rowData: null,
        pageSize: 20,
        searchQuery: null,
        filterQuery: null,
        total: 0,
        currentPage: 1,
    });

    useEffect(() => {
        fetchGridData(state.currentPage);
    }, [state.currentPage, state.searchQuery, state.filterQuery, activeTab]);

    const onPaginationChange = (page, pageSize) => {
        if (page === 0 || page === null) {
            page = 1;
        }
        gridApi.showLoadingOverlay();
        setState({ ...state, pageSize: pageSize, currentPage: page });
    };

    const fetchGridData = (pageNo) => {
        let values = "";
        if (pageNo !== null) {
            values = "?page=" + pageNo;
        }

        if (state.pageSize !== null) {
            values += "&pageSize=" + state.pageSize;
        }

        if (state.searchQuery !== null) {
            values += "&" + state.searchQuery;
        }

        values += "&filter=1" + "&status=" + activeTab 
        if (state.filterQuery !== null) {
            values += "&" +state.filterQuery
        }

        dataProvider.getPrevFeedback(values)
            .then((res) => {
                if (res.ok) {
                    res.json().then((rowData) => {
                        try {
                            gridApi.hideOverlay();
                        } catch (e) { }
                        setState({
                            ...state,
                            total: rowData.total,
                            rowData: rowData.results,
                        });
                    });
                } else {
                    res.json().then((responseJson) => {
                        openNotification("error", "Error", responseJson["message"]);
                    });
                }
            })
            .catch(() => {
                openNotification(
                    openNotificationType.error,
                    notificationTitle.api,
                    notificationMessage.apiConnectionError
                );
            });
    };

    const cellLinkButtonClick = (e) => {
        if (e.id != null) {
            if(activeTab=='Completed'){
                history.push(route_url.url + "/ViewFeedback/" + e.id);    
            }else{
                history.push(route_url.url + "/SubmitFeedback/" + e.id);
            }
        } else {
            openNotification(
                openNotificationType.error,
                notificationTitle.form,
                notificationMessage.apiConnectionError
            );
        }
    };

    const handleNewButtonClick = () => {
        history.push(route_url.url + '/RequestFeedback');
    };

    const handleFilterApply = (querystring) => {
        gridApi.showLoadingOverlay();
        setState({ ...state, filterQuery: querystring, currentPage: 1 });
    };

    const handleResetFilter = () => {
        gridApi.showLoadingOverlay();
        setState({
            ...state,
            filterQuery: null,
            currentPage: 1,
        });
    };

    const handleResetSearch = () => {
        gridApi.showLoadingOverlay();
        setState({ ...state, searchQuery: null, });
    };

    const handleSearchApply = (value, customSearch) => {
        gridApi.showLoadingOverlay();
        let quer_param;
        if(customSearch)
            quer_param = "custom_search=" + value
        else
            quer_param = "search=" + value
        if (value === "") {
            quer_param = null;
        }
        setState({ ...state, searchQuery: quer_param, currentPage: 1 });
    };

    let gridHeight = window.innerHeight - 400 + "px";
    FEEDBACK_LIST_COLUNMN_DEFS.map((column, index) => {
        if (["contractor_name"].includes(column.field)) {
            column['cellRendererParams'] = { cellLinkButtonClick: cellLinkButtonClick }
        }
    });

    let grid = (
        <AgGridReact
            ref={gridRef}
            columnDefs={FEEDBACK_LIST_COLUNMN_DEFS}
            rowData={state.rowData}
            pagination={false}
            onGridReady={onGridReady}
            onFirstDataRendered={onFirstDataRendered}
            frameworkComponents={{
                FeedbackListCellButton,
            }}
        ></AgGridReact>
    );


    return (
        <div className="col-md-12">
            <ListHeader
                excelExport={() => { }}
                showListHeader={true}
                addButton={true}
                columnFilterButton={false}
                columnDefs={[]}
                addFilters={true}
                onSearch={(q, custom_search) => handleSearchApply(q, custom_search)}
                onFilter={(q) => handleFilterApply(q)}
                onResetSearch={() => handleResetSearch()}
                onResetFilter={() => handleResetFilter()}
                addField={handleNewButtonClick}
            />
            <div className="grid-background">
                <div className="row">
                    <div className="col-md-12">
                        <Tabs
                            defaultActiveKey="my_observation"
                            activeKey={activeTab}
                            onChange={setActiveTab}
                        >
                            <Tabs.TabPane tab="Open for Feedback" key="Open for Feedback">
                                <div
                                    id="grid"
                                    className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
                                    style={{ height: gridHeight }}
                                >
                                    {grid}
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Pending for Approval" key="Pending for Approval">
                                <div
                                    id="grid"
                                    className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
                                    style={{ height: gridHeight }}
                                >
                                    {grid}
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Under Review" key="Under Review">
                                <div
                                    id="grid"
                                    className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
                                    style={{ height: gridHeight }}
                                >
                                    {grid}
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Completed" key="Completed">
                                <div
                                    id="grid"
                                    className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
                                    style={{ height: gridHeight }}
                                >
                                    {grid}
                                </div>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
            <div>
                <ListFooter
                    total={state.total}
                    currentPage={state.currentPage}
                    onShowSizeChange={(pageNo, pageSize) =>
                        onPaginationChange(pageNo, pageSize)
                    }
                    onPaginationChange={(pageNo, pageSize) =>
                        onPaginationChange(pageNo, pageSize)
                    }
                />
            </div>
        </div>
    );
};

export default AllFeedback;
